module.exports = __webpack_public_path__ + "assets/e5d9d1254bc68d66161893521d69e5ad.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ro/video.webm
// module id = 356
// module chunks = 1